import React from "react";
import { useTranslation } from "react-i18next";

import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";

const PositionItem = ({ position }) => {
  const { t } = useTranslation();
  return (
    <TableRow>
      <TableCell>{position.id}</TableCell>
      <TableCell>{position.name}</TableCell>
      <TableCell>{position.role.name}</TableCell>
      <TableCell>{position.status === "active" ? t("active") : t("not_active")}</TableCell>
    </TableRow>
  );
};

export default PositionItem;
